const severityArray = ['error', 'warning', 'info', 'success'] as const;

export type SeverityType = (typeof severityArray)[number];

export const severity = severityArray.reduce((obj, key) => {
  obj[key] = key;
  return obj;
}, {} as Record<SeverityType, SeverityType>);
